import { useEffect, useState } from "react";

import "./Help.css";
import IHelp from "pages/Help/IHelp";

import { GetLocales } from "assets/customAssets";
import CustomButton from "components/CustomButton/CustomButton";
import { CustomButtonType } from "components/CustomButton/CustomButtonType";
import { Enhanced } from "utils/ReactUtils";
import { DONT_ALLOW_INSTALL_PROMPT, LAST_INSTALL_PROMPT_TIMESTAMP } from "types/global";

const Help: React.FC<IHelp> = ({ t }) => {
	const [permettiPromptInstallazione, setPermettiPromptInstallazione] = useState<boolean>(false);

	const locales = GetLocales();

	useEffect(() => {
		const stored = localStorage.getItem(DONT_ALLOW_INSTALL_PROMPT);
		if (stored !== null) setPermettiPromptInstallazione(false);
		else {
			const lastRequest = localStorage.getItem(LAST_INSTALL_PROMPT_TIMESTAMP);
			if (lastRequest !== null) {
				const lastTime = parseInt(lastRequest);
				const now = new Date().getTime();
				if (Math.abs(now - lastTime) < window.CONFIG.REACT_APP_INSTALL_PWA.REITERATE_INSTALL_PROMPT_INTERVAL)
					setPermettiPromptInstallazione(false);
			} else setPermettiPromptInstallazione(true);
		}
	}, []);

	const resetInstallPrompt = () => {
		localStorage.removeItem(DONT_ALLOW_INSTALL_PROMPT);
		localStorage.removeItem(LAST_INSTALL_PROMPT_TIMESTAMP);
	};

	return (
		<div id="helpSection">
			<div className="help-header">
				<span className="title help-title">{t("helpTitolo")}</span>
			</div>
			<p>{t("helpIntroduzione")}</p>
			<span className="subtitle help-installation-title">{t("installazioneTitolo")}</span>
			<div className="help-reset-prompt">
				{!permettiPromptInstallazione && (
					<>
						<p>{t("installazioneRiattivaPrompt")}</p>
						<CustomButton className="button" buttonType={CustomButtonType.positive} text={"Riattiva"} OnClick={resetInstallPrompt} />
					</>
				)}
			</div>
			<p></p>
			<iframe title="tutorial-pwa" allowFullScreen src={locales.TutorialPwa} />
		</div>
	);
};

export default Enhanced(Help, { componentNamespace: "Help" });
// export default Help;
